import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import Require from "~common/components/require"
import FormEditView from "~forms/components/form-edit-view"
import FormAdminQueryList from "~forms/components/form-query-view"
import {Typography} from '@mui/material'




const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  status: "loading" | "ready"
}

class FormAdmin extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {status: "ready"}
  }

  render() {

    const {match} = this.props;
    const { classes, history}: {classes: ClassNameMap; history: any} = this.props
    const { status} = this.state
    var selectedFormID
    if(match && match.params && match.params.id) {
      selectedFormID = match.params.id
    }

    var view 

    if (status === "loading") {
      view = <LoadingView classes={{}} />
    } else if (selectedFormID) {
      view = <FormEditView match={match} history={history} classes={{}} />
    } else {
      view = <FormAdminQueryList></FormAdminQueryList> //match={match} history={history} classes={{}} />
    }

    return (
      <AppView>
        <Require classes={{}} requireOneOfFeatures={["form_admin"]}>
          <Typography id="formAdminTitle" variant="h5" className={classes.heading}>
               Form Administration
            </Typography>
            <div className={classes.container}>{view}</div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(FormAdmin)

